module.exports = __webpack_public_path__ + "static/media/X@2x.b0da9ccd.png";